/* eslint-disable @typescript-eslint/camelcase */
import {SyntheticEvent} from 'react';

import type {
    FilterGroupType,
    Refinement,
} from '../components/FilterBar/FilterBar';

import type {
    CustomFilterParams,
    TriggerEventData,
} from '../components/FilterBar/FilterBar';

import {
    INSTANT_BOOK_FILTER_ID,
    INSTANT_BOOK_FILTER_LABEL,
    FREE_CANCEL_60_DAYS_ID,
    FREE_CANCEL_30_DAYS_ID,
    FREE_CANCEL_14_DAYS_ID,
    LEGACY_INSTANT_BOOK_ID,
    FREE_CANCELLATION_GROUP_ID,
} from '../constants/filters';

export const getCancellationFilterId = (filter: any): string | null => {
    const filtered = []
        .concat(filter || [])
        .map((f: string) => f.toLowerCase().trim())
        .filter(
            (f) =>
                FREE_CANCEL_60_DAYS_ID === f ||
                FREE_CANCEL_30_DAYS_ID === f ||
                FREE_CANCEL_14_DAYS_ID === f
        );
    return filtered.length ? filtered[0] : null;
};

// eslint-disable-next-line complexity
export const getFilterId = (event: SyntheticEvent<HTMLInputElement>) => {
    const filterId =
        (event.currentTarget && event.currentTarget.getAttribute('name')) || '';
    const matches = filterId.match(/:(.+$)/);

    if (!matches) {
        return null;
    }

    if (
        filterId === INSTANT_BOOK_FILTER_ID ||
        filterId === LEGACY_INSTANT_BOOK_ID
    ) {
        return INSTANT_BOOK_FILTER_LABEL;
    }

    return matches[1];
};

export function getGroupFiltersSelected(
    groupFilters: Refinement[],
    selectedFilters: string[]
): Refinement[] {
    return groupFilters.filter(({filter}) => {
        return selectedFilters.includes(filter.refineByQueryArgument);
    });
}
export const getFreeCancellationFilters = (
    filterGroups: FilterGroupType[] = []
) => {
    const freeCancellationGroup = filterGroups.find(({groupInfo}) => {
        return groupInfo.id === FREE_CANCELLATION_GROUP_ID;
    });
    const filters = freeCancellationGroup && freeCancellationGroup.filters;
    return filters ? filters : [];
};

export function getEventParams(
    customFiltersParams: CustomFilterParams
): TriggerEventData {
    const {
        selectedFilterByTotalPrice,
        selectedMaxNightlyPrice,
        selectedMaxTotalPrice,
        selectedMinNightlyPrice,
        selectedMinTotalPrice,
    } = customFiltersParams;
    const price_filter_selection = selectedFilterByTotalPrice
        ? 'total'
        : 'nightly';
    const max_price = selectedFilterByTotalPrice
        ? selectedMaxTotalPrice
        : selectedMaxNightlyPrice;
    const min_price = selectedFilterByTotalPrice
        ? selectedMinTotalPrice
        : selectedMinNightlyPrice;
    const maxprice = max_price ? max_price.toString() : '-1';
    const minprice = min_price ? min_price.toString() : '-1';

    const pricesAreNotDefault = min_price || max_price;
    const eventParams = {
        action_location: 'search',
        platform_source: 'desktop',
        minprice,
        maxprice,
        price_filter_selection,
    };
    return {
        pricesAreNotDefault,
        eventParams,
    };
}
